import {Injectable} from '@angular/core';
import {IConnectorsEdges, IGraphNode, ILayerData, ITagretsNodes,  TGraphType} from '../models/graph-kn.model-interfaces';
import {Rect, RectConfig} from 'konva/lib/shapes/Rect';
import {Text, TextConfig} from 'konva/lib/shapes/Text';
import {Group} from 'konva/lib/Group';
import {Layer} from 'konva/lib/Layer';
import {GraphKnDataService} from './graph-kn.data.service';
import {GraphKnUIElementsService} from './graph-kn.ui.elements.service';
import {Contract_Steps_Icons} from '../styles/nodes-styles/graph-node-contract-step-styling';
import {GraphKnHelperService} from './graph-kn.helpers.service';
import {KN_ICONS_MAP} from '../models/graph-kn-icons-map';
import {GraphKnNodeEventsService} from './graph-kn.node-events.service';
import {
    COMPLETED_STEP_BORDER_COLOR,
    COMPLETED_STEP_BORDER_WIDTH,
    COMPLETED_TARGET_BORDER_COLOR,
    COMPLETED_TARGET_BORDER_WIDTH,
    CONTRACT_ACTIVE_STEP_COLOR,
    CONTRACT_ACTIVE_STEP_WIDTH,
    CONTRACT_STEP_ERROR_COLOR,
    CONTRACT_STEP_ERROR_WIDTH,
    defaultNodeLineColor,
    IContractNodeStyleConfing,
    INodeStyleConfing,
    STATUS_ICON_RIGHT_PADDING,
} from '../models/graph-kn.cm.nodes-model-const';
import { Line } from 'konva/lib/shapes/Line';
import { GraphKnUIAvatarService } from './graph-kn.ui.avatar-panel.service';
import { Image } from 'konva/lib/shapes/Image';
import { RectModelsMap } from '../styles/graph-node-rect-model';
import { NodesStylingMap } from '../styles/nodes-styles/graph-node--map-styles-root';
import { TLayerIDs } from '../models/graph-kn.cm-api-models';
import { GraphKnLayerService } from './graph-kn.layer.service';

const NODE_GROUP_ATTR = {
    scaleX: 1,
    scaleY: 1,
    draggable: true,
    rotation: 0,
}

@Injectable({
    providedIn: 'root'
})
export class GraphKnNodeCreateService {
    constructor(
        private knDataService: GraphKnDataService,
        private knUIElementsService: GraphKnUIElementsService,
        private knUIAvatarService: GraphKnUIAvatarService,
        private knHelperService: GraphKnHelperService,
        private knNodeEventsService: GraphKnNodeEventsService,
        private knLayerService:GraphKnLayerService
    ) {
    }
    createNodeRoot(targetsNodes:ITagretsNodes[],connectorsEdges:IConnectorsEdges[], graphLayer:Layer,layerId:TLayerIDs, graphLayerData: ILayerData) {
        targetsNodes.forEach((target) => {
			let nodeGroup = this.createNewNode(target, layerId)
			graphLayer.add(nodeGroup)
			this.knLayerService.adjustLayerDimensions(nodeGroup, graphLayerData)
			this.addEventHandlerToNodeGroup(nodeGroup, connectorsEdges, graphLayer, layerId, target, targetsNodes);
		});
    }
    createNewNode(target: ITagretsNodes, layerId: TGraphType): Group {
        let uiSettings = this.knDataService.graphUISetting.get(layerId)
        let rectModel = RectModelsMap.get(target.node.nodeType)!
        let nodeCSSSettings = NodesStylingMap.get(target.node.nodeType)!
        let nodeGroup = new Group({
            dimensions: target.node.dimension,
            x: target.x,
            y: target.y,
            id: target.node.id.toString(),
            name:'Node',
            data: target.node,
            active: false,
            ...NODE_GROUP_ATTR,
            draggable:uiSettings?.draggable,
        });
        let nodeRect: Rect;
        nodeRect = new Rect({
            id:'GroupRect',
            ...rectModel,
            width:  target.node.dimension.width,
            height: target.node.dimension.height,
        })
        nodeRect.perfectDrawEnabled(false)
        nodeGroup.add(nodeRect);
        //this.addStatusesBoarders(target, nodeRect, nodeGroup)
        let colorCode = 
            target.node.bp_status_data?.data?.colorCode|| 
            target.node.task_data?.data?.colorCode|| 
            defaultNodeLineColor
        let typedNodeCSS = nodeCSSSettings as INodeStyleConfing
        //добавление цветовой линии, если она есть в стилях ноды
        typedNodeCSS.fronLineWidth? this.addFrontColorLine(nodeGroup,colorCode,rectModel,typedNodeCSS.fronLineWidth) : null
        this.createNodeContent(nodeGroup, target, rectModel!);
         // создание статуса загрузки для неполных этапов
        if (this.knDataService.loadingIds.includes(target.node.id)) {
            this.knUIElementsService.createLoadingState(nodeGroup, target.node.id);
        }
        typedNodeCSS.statusPanel? this.knUIElementsService.createStatusPanel(nodeGroup, target.node , rectModel, typedNodeCSS) : null
        typedNodeCSS.avatarPanel? this.knUIAvatarService.createAvatarsPanel(nodeGroup, target.node, rectModel) : null
        return nodeGroup;
    }
    createNodeContent(nodeGroup: Group, target: ITagretsNodes, rectModel:RectConfig) {
        let nodeCSSSettings = NodesStylingMap.get(target.node.nodeType)!
        //this.addStatusesIcons(nodeGroup, target)
        // номер этапа
        let additionlOffsetX = 0
        let typedNodeCSSContract = nodeCSSSettings as IContractNodeStyleConfing;
        if (typedNodeCSSContract.textCounter) {
          let textCounter = new Text({
            text: target.node.contract_step_data?.stepNumber,
            id: target.node.id + 'text_number',
            height: target.node.dimension.height,
            ...typedNodeCSSContract.textCounter
          })
          additionlOffsetX = additionlOffsetX - textCounter.getTextWidth() - typedNodeCSSContract.counterGap
          nodeGroup.add(textCounter)
        }
        // иконка этапа
        let iconPath:string|undefined = target.node.contract_step_data?.target_type? Contract_Steps_Icons.get(target.node.contract_step_data.target_type)?.stepIcon : undefined
		if (typedNodeCSSContract.icon && iconPath) {
			Image.fromURL(iconPath, (image) => {
				image.id(target.node.id + 'icon')
				image.width(typedNodeCSSContract.icon.iconHeight)
				image.height(typedNodeCSSContract.icon.iconHeight)
				image.offsetY(target.node.dimension.height!/2 * -1 + typedNodeCSSContract.icon.iconHeight/2)
				image.offsetX(additionlOffsetX)
				nodeGroup.add(image);
				additionlOffsetX = additionlOffsetX - typedNodeCSSContract.icon.iconHeight - typedNodeCSSContract.iconGap
				// название этапа
				let textModel:TextConfig = nodeCSSSettings.textMain
				let textMain = new Text({
					text: target.node.label,
					id: target.node.id + 'text',
					...textModel,
					width: target.node.dimension.width -((textModel.offsetX||0 + additionlOffsetX) * -1),
					height: target.node.dimension.height! ,
					offsetX:textModel.offsetX||0 + additionlOffsetX
				})
				nodeGroup.add(textMain);
			});
		} else {
			// название этапа
			let textModel:TextConfig = nodeCSSSettings.textMain
			let textMain = new Text({
				text: target.node.label,
				id: target.node.id + 'text',
				...textModel,
				width: target.node.dimension.width! -((textModel.offsetX||0 + additionlOffsetX) * -1) - 10,
				height: target.node.dimension.height,
				offsetX:textModel.offsetX||0 + additionlOffsetX
			})
			nodeGroup.add(textMain);
		}
    }
    addFrontColorLine(nodeGroup:Group, colorCode:string,rectModel:RectConfig,lineWidth:number) {
        let nodeData = nodeGroup.attrs.data as IGraphNode
        let cornerRadius = rectModel.cornerRadius as number
        let line = new Line({
            id:'GroupLine',
            x:0,
            y:0,
            stroke:colorCode,
            points:[lineWidth/2,cornerRadius,lineWidth/2,(nodeData.dimension.height-cornerRadius)],
            strokeWidth:lineWidth,
            lineCap: 'round',
        })
        nodeGroup.add(line)
    }
    addStatusesBoarders(target: ITagretsNodes, rect: Rect, group: Group) {
        if (target.target_completed) {
            rect.stroke(COMPLETED_TARGET_BORDER_COLOR);
            rect.strokeWidth(COMPLETED_TARGET_BORDER_WIDTH);
        }
        if (target.step_completed) {
            rect.stroke(COMPLETED_STEP_BORDER_COLOR);
            rect.strokeWidth(COMPLETED_STEP_BORDER_WIDTH);
        }
        if (target.active_step) {
            rect.stroke(CONTRACT_ACTIVE_STEP_COLOR);
            rect.strokeWidth(CONTRACT_ACTIVE_STEP_WIDTH);
        }
        if (target.target_errors) {
            rect.stroke(CONTRACT_STEP_ERROR_COLOR);
            rect.strokeWidth(CONTRACT_STEP_ERROR_WIDTH);
        }
    }

    addStatusesIcons(nodeGroup: Group, target: ITagretsNodes) {
        let rect = nodeGroup.children.filter(el => el instanceof Rect)[0] as Rect
        if (target.step_completed) {
            let icon = KN_ICONS_MAP.get('COMPLETED_STEP')!
            Image.fromURL(icon.path, (image) => {
                image.x(rect.width() - image.width() * STATUS_ICON_RIGHT_PADDING);
                image.offsetY(icon.offsetY);
                image.scale(icon.scale)
                nodeGroup.add(image);
            });
        }
        if (target.step_completed === false && target.target_completed === true) {
            let icon = KN_ICONS_MAP.get('COMPLETED_TARGET')!
            Image.fromURL(icon.path, (image) => {
                image.x(rect.width() - image.width() * STATUS_ICON_RIGHT_PADDING);
                image.offsetY(icon.offsetY);
                image.scale(icon.scale)
                nodeGroup.add(image);
            });
        }
        if (target.active_step === true) {
            let icon = KN_ICONS_MAP.get('ACTIVE_STEP')!
            Image.fromURL(icon.path, (image) => {
                image.x(rect.width() - image.width() * STATUS_ICON_RIGHT_PADDING);
                image.offsetY(icon.offsetY);
                image.scale(icon.scale)
                nodeGroup.add(image);
            });
        }
    }

    addEventHandlerToNodeGroup(nodeGroup: Group, connectorsEdges: IConnectorsEdges[],
        graphLayer: Layer, graphType: TGraphType, target: ITagretsNodes, targetsNodes: ITagretsNodes[]) {
        nodeGroup.on('mouseenter',()=>this.knUIElementsService.togglePointer('pointer'))
        nodeGroup.on('mouseleave',()=>this.knUIElementsService.togglePointer('default'))
        let isContractOpen: boolean = this.knHelperService.isContractOpen(target.contractState, graphType)
        nodeGroup.on('click', e => this.knNodeEventsService.nodeClickEventHandler(e, nodeGroup, graphType, isContractOpen,connectorsEdges));
        this.knNodeEventsService.createDragEvents(nodeGroup, graphLayer, connectorsEdges, targetsNodes, graphType, isContractOpen);
        this.knNodeEventsService.createMobileEvents(nodeGroup, graphType, isContractOpen,connectorsEdges);
    }
}